import { Item } from '@/helper/types';
import httpClient from './http-client';
import { ItemModel } from '@/models/item.model';

function list() {
  return httpClient.get<ItemModel[]>('items');
}

function get(id: string) {
  return httpClient.get<ItemModel>(`items/${id}`);
}

function post(newItemObj: Item) {
  return httpClient.post('items', newItemObj);
}

function update(itemId: string, newItemObj: Item){
  console.log(newItemObj)
  return httpClient.put( `items/${itemId}`,{newItemObj});
}

function remove(id: string) {
  return httpClient.delete(`items/${id}`);
}

export const itemsClient = {
  list,
  get,
  post,
  remove,
  update
};
